import {computed, observable} from "mobx";
import {IndicadorService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";

export default class QuantidadeMOTFornecedorStore {
    @observable erro;
    @observable carregando;
    @observable dados;
    @observable empresasGlobo;
    @observable dadosNaoTratados;
    @observable activeTab;

    constructor() {
        this.indicadorService = new IndicadorService();

        this.activeTab = '1';
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.indicadorService.findQuantidadeMOTFornecedor(filtro).then(response => {
            const fornecedoresAgrupados = _.groupBy(response.data, (d) => d.fornecedor);
            const fornecedores = Object.keys(fornecedoresAgrupados);
            const empresasGloboAgrupadas = _.groupBy(response.data, (d) => d.empresaGlobo);
            const empresasGlobo = Object.keys(empresasGloboAgrupadas);

            let dados = [];
            _.forEach(fornecedores, (fornecedor) => {
                let dado = { nome: fornecedor };

                const fornecedoresEmpresasGlobo = fornecedoresAgrupados[fornecedor];

                _.forEach(fornecedoresEmpresasGlobo, (fornecedorEmpresaGlobo) => {
                    dado = { ...dado, [fornecedorEmpresaGlobo.empresaGlobo]: fornecedorEmpresaGlobo.quantidade };
                });

                dados = [ ...dados, dado ];
            });

            this.dadosNaoTratados = response.data.map((dado) => ({
                nome: `${dado.fornecedor} + ${dado.empresaGlobo}`,
                "Quantidade": dado.quantidade
            }));

            this.empresasGlobo = empresasGlobo;
            this.dados = dados;
            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }

    toggle = (tab) => {
        if (this.activeTab !== tab) {
            this.activeTab = tab;
        }
    }
}
